import React, { Component } from "react";
import Image from '../global/Image';
import FadeIn from "react-lazyload-fadein";
import { Link } from 'react-router-dom';

export default class PageMrkSpecialists extends Component {
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--space-' + block.space_after + ' c-page__block--' + block.rule_after}>
			    
			    	<div className="c-mrk-specialists">
			    
				    	<div className="l-content l-content--fixed-width">
				    		
				    		<div className="l-grid">
				    		
				    			<div className="l-grid__col l-grid__col--m-8-12">
				    				
				    				<div className="c-mrk-specialists__text">
				    				
					    				{block.heading &&
						    				<div className="c-mrk-specialists__heading" dangerouslySetInnerHTML={{__html:block.heading}}></div>
					    				}	  
					    				
					    				{block.text &&
						    				<div className="scope-text scope-text--faded" dangerouslySetInnerHTML={{__html:block.text}}></div>
					    				}
					    				
					    			</div>
				    				
				    			</div>
				    			
				    			<div className="l-grid__col">
																	
									<div className="c-mrk-specialists__agents">
					    					
				    					{block.agents.map((agent,i) =>
			    							{
						    					return (
							    					<div className="c-mrk-specialists__agents__agent">
								    					<Link to={{ pathname: agent.url }} className="c-mrk-specialists__agents__agent__inner">
								    						<div className="c-mrk-specialists__agents__agent__headshot">
								    							<FadeIn>
																	{onload => (
																		<img
																			alt={''} 
																			src={agent.src} 
																			srcSet={agent.srcset} 
																			onLoad={onload}
																		/>
																	)}
																</FadeIn>
								    						</div>
								    						
								    						<h4 className="c-mrk-specialists__agents__agent__text" dangerouslySetInnerHTML={{__html:agent.name + ' - ' + agent.role}}></h4>
								    						{agent.phone &&
									    						<p className="c-mrk-specialists__agents__agent__text" dangerouslySetInnerHTML={{__html:agent.phone}}></p>
								    						}
								    						{agent.email &&
									    						<p className="c-mrk-specialists__agents__agent__text" dangerouslySetInnerHTML={{__html:agent.email}}></p>
								    						}
								    					</Link>	
								    				</div>	
							    				)
						    				}
						    			)}
												
				    				</div>
					    			
					    		</div>
					    		
					    	</div>
				    		
				    	</div>
			    	
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
